import React, { useEffect } from 'react';
import './features.css';  // Ensure to add the necessary CSS styles for your features section
import AOS from 'aos';
import 'aos/dist/aos.css';  // AOS styles

const Features = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,  // Duration for animations (can be customized)
    });
  }, []);

  return (
    <section id="features" className="features section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Features</h2>
        <p>Our software solutions are crafted to deliver reliability, scalability, and innovation, driving your business forward.</p>
      </div>

      <div className="container">



        {/* Feature Item 1 */}
        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 order-1 order-md-2 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
            <img src="assets/img/features/feature2.png" className="img-fluid" alt="" />
          </div>
          <div className="col-md-7 order-2 order-md-1" data-aos="fade-up" data-aos-delay="200">
            <h3>Empowering Businesses Through Technology</h3>
            <p className="fst-italic">
              Our software development services are designed to help businesses enhance their digital presence and streamline operations. We create solutions that are both innovative and cost-effective for long-term success.
            </p>
            <p>
              By leveraging modern technology and industry best practices, we build secure and adaptable software that supports growth. Our team ensures that every project is delivered with precision and within the set timelines.
            </p>
          </div>
        </div>

        {/* Feature Item 2 */}
        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out">
            <img src="assets/img/features/feature1.png" className="img-fluid" alt="" />
          </div>
          <div className="col-md-7" data-aos="fade-up">
            <h3>Delivering Excellence in Software Solutions</h3>
            <p>We are committed to providing innovative, cost-effective, and high-quality software and web development services tailored to your needs.</p>
            <ul>
              <li><i className="bi bi-check"></i> <span>Every project is driven by a commitment to excellence and client satisfaction.</span></li>
              <li><i className="bi bi-check"></i><span> We offer budget-friendly website development without compromising on quality</span></li>
              <li><i className="bi bi-check"></i> <span>Our creative and tailored solutions help businesses stand out and succeed.</span>.</li>
            </ul>
          </div>
        </div>

        {/* Feature Item 3 */}
        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 order-1 order-md-2 d-flex align-items-center" data-aos="zoom-out">
            <img src="assets/img/features/feature4.png" className="img-fluid" alt="" />
          </div>
          <div className="col-md-7 order-2 order-md-1" data-aos="fade-up">
            <h3>Transforming Ideas into Seamless Digital Solutions</h3>
            <p className="fst-italic">
              We specialize in creating custom software solutions tailored to your business needs, ensuring efficiency and high performance. Our team works closely with clients to deliver reliable, scalable products that make a real impact.
            </p>
            <p>
              With expertise in the latest technologies, we focus on developing intuitive and user-friendly software. We’re committed to providing ongoing support and maintenance to ensure your software evolves with your business.
            </p>
          </div>
        </div>
        {/* Feature Item 4 */}
        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="100">
            <img src="assets/img/features/feature3.png" className="img-fluid" alt="" />
          </div>
          <div className="col-md-7" data-aos="fade-up" data-aos-delay="100">
            <h3>Embodying Excellence and Responsibility</h3>
            <p className="fst-italic">
              We provide dignified solutions with a commitment to quality and precision. Our focus on integrity and accountability ensures unmatched service, setting us apart in the industry.
            </p>
            <ul>
              <li><i className="bi bi-check"></i><span> Dedicated to delivering uncompromising quality and care.</span></li>
              <li><i className="bi bi-check"></i> <span>Focused on meeting and exceeding expectations with precision.</span></li>
              <li><i className="bi bi-check"></i> <span>Built on a foundation of integrity, accountability, and trust.</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
